import React from 'react'
import { SaveCancelButtons } from '@ztechapps/webui.button'
import { useContext } from './Context'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'

export const Footer = ({ disabled, onSave, isBusy }: { disabled?: boolean; onSave?: () => void; isBusy?: boolean }) => {
  const { newTasks, addTask, activeTab, onCancel } = useContext()

  const loading = isNil(isBusy) ? addTask?.loading : isBusy
  const _disabled = isNil(disabled) ? isEmpty(newTasks) : disabled

  const _onSave = async () => {
    if (onSave) {
      await onSave()
    } else {
      await addTask?.action({ tasks: newTasks, activeTab })
    }
    onCancel?.()
  }

  return (
    <div className="d-flex justify-content-end">
      <SaveCancelButtons onSave={_onSave} disabled={_disabled} isBusy={loading} onCancel={onCancel} />
    </div>
  )
}
